import { useCallback, useEffect, useState } from 'react'
import { BuyerProposalDetailDto } from '../../shared/types.ts'
import { ProposalsApi } from '../../../api/proposals-api.ts'

export default function useBuyerProposal(proposalId?: string | null) {
  const [proposal, setProposal] = useState<BuyerProposalDetailDto | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>()

  const loadProposal = useCallback(async () => {
    if (!proposalId) return
    setLoading(true)
    try {
      const data = await ProposalsApi.getBuyerProposal(proposalId)
      setProposal(data)
      setError(undefined)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [proposalId])

  useEffect(() => {
    void loadProposal()
  }, [loadProposal])

  return { proposal, loading, error, reload: loadProposal }
}
